// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__HGoae","modal":"Modal_modal__OW0m8"};